// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"11985b5f","101":"55468b67","356":"5386a7d2","453":"6c2e90ed","486":"74b5ed35","560":"59087a56","703":"809aa957","712":"67e9f209","721":"db22df02","769":"2c01cc45","837":"a442a2a5"}[chunkId] + ".chunk.js";
};